import { render, staticRenderFns } from "./attributeClassification.vue?vue&type=template&id=9d638414&"
import script from "./attributeClassification.vue?vue&type=script&lang=js&"
export * from "./attributeClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports